import phone from "../assets/images/phone.svg"
import gmail from "../assets/images/gmail.svg"

export default [
  {
    id: 1,
    title: "+91 9810257340",
    icon: phone,
    linkTo: false,
  },
  {
    id: 2,
    title: "prateekmadaan12@gmail.com",
    icon: gmail,
    linkTo: false,
  },
]
